<template>
  <div>
    <CRow>
      <CCol sm="6">
        <p>
          Showing {{ total > 0 ? from : 0 }} to {{ to }} of {{ total }} entries
        </p>
      </CCol>
      <CCol sm="6">
        <CPagination
          align="end"
          :active-page.sync="currentPage"
          :pages="totalPage"
          @update:activePage="changePage"
          ref="pagination"
        />
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { bus } from "@/main.js";
export default {
  props: ["recordPerPage", "total"],
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    from() {
      return this.recordPerPage * this.currentPage - this.recordPerPage + 1;
    },
    to() {
      return this.recordPerPage * this.currentPage > this.total
        ? this.total
        : this.recordPerPage * this.currentPage;
    },
    totalPage() {
      return Math.ceil(this.total / this.recordPerPage);
    },
  },
  created() {
    bus.$on("PAGE_CHANGE", (page = 1) => {
      this.gotoPage(page);
    });
  },
  beforeDestroy() {
    bus.$off("PAGE_CHANGE");
  },
  methods: {
    changePage(currentPage, reduced) {
      if (reduced) this.gotoPage();
      this.$emit("changePage", { currentPage: currentPage, reduced: reduced });
    },
    gotoPage(page = 1) {
      this.$refs.pagination.setPage(page);
    },
  },
};
</script>